// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1x-2";
export var blackBorderOnHover = "_1x-7";
export var cell = "_1x-6";
export var cellContainer = "_1x-3";
export var checked = "_1x-8";
export var disabled = "_1x-5";
export var featuredIconCellContainer = "_1x-9";
export var featuredIconTextContainer = "_1x-b";
export var featuredIconWrapper = "_1x-a";
export var noBorder = "_1x-c";
export var orangeSelectedRow = "_4m-3";
export var overflowableText = "_1x-0";
export var overflowableTextContainer = "_1x-1";
export var row = "_1w-0";
export var rowCheckboxCell = "_1x-4";
export var selectableTable = "_4m-2";